import React, { useEffect, useState, useContext } from 'react'
import styled from 'styled-components'
import CarSvg from '../../../assets/car.svg'
import TripsContext from '../../contexts/TripsContext'

type IProps = {
    trips: any[]
    status?: string
}

const TripProgress = ({ trips = [], status }: IProps): JSX.Element => {
    const { tripHoverActive, tripActive } = useContext(TripsContext)
    const [indexTripActive, setIndexTripActive] = useState(undefined)

    useEffect(() => {
        const index = trips.findIndex(ele => ele?.uid === tripActive?.uid)
        if (index === -1 || tripActive === undefined) setIndexTripActive(undefined)
        else setIndexTripActive(index)
    }, [tripActive])

    const buildSquares = trips => {
        const aux = []
        let initialTop = -5

        // visibility:

        for (let i = 0; i < trips.length; i++) {
            const obj = { top: initialTop, id: trips[i].uid, visibility: 'initial' }

            if (i === 0 && status === 'moving') obj.visibility = 'hidden'

            aux.push(obj)

            if (i === 0) initialTop += 173
            else if (i > 0) initialTop += 129
        }

        return aux
    }

    const buildHighlight = trips => {
        const aux = []
        let initialTop = 4

        for (let i = 0; i < trips.length; i++) {
            aux.push({ top: initialTop, id: trips[i].uid })

            if (i === 0) initialTop += 173
            else if (i > 0) initialTop += 129
        }

        return aux
    }

    const calcHeight = index => {
        if (index === 0) return 178
        else if (index > 0 && index < trips.length - 1) return 130
        else if (index === trips.length - 1) return 47
    }

    const calcFullHeight = totalTrips => {
        return -25 + 121 * totalTrips + 8 * (totalTrips - 1)
    }

    return (
        <StyledProgress>
            <ContainerArrow>
                <i className="fas fa-angle-right fa-rotate-270"></i>
            </ContainerArrow>

            <ContainerSvg>
                <div style={{ position: 'absolute', left: 12, background: '#f5f5f5' }}>
                    <div style={{ display: status === 'moving' ? 'block' : 'none' }}>
                        <CarSvg />
                    </div>
                </div>
            </ContainerSvg>

            <ContainerLines>
                {buildSquares(trips).map(({ top, id, visibility }, index) => {
                    return (
                        <StyleSquare key={index}>
                            <img
                                style={{ position: 'relative', height: 21, top: top, visibility }}
                                src={`${tripHoverActive?.uid === id
                                        ? '/content/plugin-widget-gmaps/marker-square-hover.svg'
                                        : '/content/plugin-widget-gmaps/marker-square.svg'
                                    }`}
                            />
                        </StyleSquare>
                    )
                })}

                {trips?.length > 0 && (
                    <>
                        <Line height={calcFullHeight(trips.length)}></Line>

                        {buildHighlight(trips)
                            .filter((ele, index) => index === indexTripActive)
                            .map(({ top }, index) => {
                                return <LineHighlight key={index} height={calcHeight(indexTripActive)} top={top} />
                            })}
                    </>
                )}
            </ContainerLines>
        </StyledProgress>
    )
}

export default TripProgress

const StyledProgress = styled.div`
    width: 13.5px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-right: 16px;

    &::before {
        height: 30px;
        width: 9px;
        background: url('/content/plugin-widget-gmaps/car.svg'), auto;
        transform: translate(74px, 0px);
        top: -17px;
        left: -4px;
        border: 2px solid black;
    }
`

const ContainerArrow = styled.div`
    color: ${({ theme }) => theme['gray-400']};
`

const ContainerSvg = styled.div`
    text-align: center;
    color: ${({ theme }) => theme['gray-400']};
    z-index: 1;
    position: relative;
    left: -20px;
`

const ContainerLines = styled.div`
    flex: 1;
    position: relative;
    display: flex;
    justify-content: center;
`

const StyleSquare = styled.div`
    position: absolute;
    z-index: 1;

    i {
        transform: rotate(45deg);
        font-size: 7px;
        position: absolute;
        left: -5px;
        top: ${({ top = 0 }) => top + 'px'};
        color: #fff;
        border: 2px solid ${({ theme }) => theme['blue-500']};
        cursor: pointer;

        &:hover {
            left: -7px;
            border: 3px solid ${({ theme }) => theme['blue-500']};
        }
    }
`

const Line = styled.div`
    height: ${({ height }) => `${height}px`};
    width: 3px;
    background: ${({ theme }) => theme['gray-400']};
    position: relative;
`

const LineHighlight = styled.div`
    background: ${({ theme }) => theme['blue-500']};
    height: ${({ height }) => `${height}px`};
    width: 8px;
    position: absolute;
    opacity: 0.5;
    top: ${({ top = 0 }) => top + 'px'};
`
